/* Diamond Domain - places the Founder's Favorites row on the homepage (Sep 2026).

   The row itself is built in Liquid by snippets/dd-founders.liquid, so its links exist in the
   page source. This only moves the finished block into position, which keeps
   templates/index.json - 30KB of generated JSON - untouched.

   It lands after the second section, so it sits below the hero rather than displacing it.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  function place() {
    var block = document.getElementById('dd-founders');
    if (!block) return true;                       /* collection empty or missing */
    if (block.dataset.ddPlaced === '1') return true;

    var main = document.querySelector('main.main-content');
    if (!main) return false;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return false;

    var after = sections[1] || sections[0];
    after.insertAdjacentElement('afterend', block);

    block.hidden = false;
    block.dataset.ddPlaced = '1';
    return true;
  }

  function start() {
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();